import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  padding: 0 8px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  min-height: ", ";\n  padding-right: ", ";\n  text-overflow: ", ";\n\n  &::placeholder {\n    ", "\n  }\n\n  &::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button,\n  &::-webkit-search-results-decoration {\n    appearance: none;\n    display: none;\n  }\n\n  &:placeholder-shown {\n    ~ ", " ", " {\n      display: none;\n    }\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &:nth-child(2) {\n    /* has an icon on the left */\n    padding-left: ", "px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  /* stylelint-disable-line no-empty-source */\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  pointer-events: ", ";\n  right: auto;\n  width: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 0;\n  box-sizing: border-box;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  padding: 0 8px;\n  position: absolute;\n  right: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  /* no styles - it's just used as selector for Input */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { PureComponent, createRef } from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { color } from '@scp/ui-shared/theme/variables';
import { placeholder } from '@scp/ui-shared/theme/typography-styles';
import { Icon } from '@scp/ui-shared/theme/icons';
import { ClearedInput } from '@scp/ui-shared/theme/resets';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { FIELD_HEIGHT } from './constants';
import { ClearButton, FieldBase } from './base';
import { Label } from './Label';
import { FieldWrapper } from './FieldWrapper';
import { getInitialMaskValue } from './utils'; // eslint-disable-next-line import/no-relative-parent-imports

import { FieldDescription } from './FieldDescription';
var ICN_SIZE = 46;
var E2E_TITLE_SUFFIX = 'field';
var E2E_INPUT_SUFFIX = '-field-input';
var InputWrapper = styled.div(_templateObject());
var ClearWrapper = styled.div(_templateObject2());
var ActionsWrapper = styled.div(_templateObject3(), FIELD_HEIGHT);
var IcnWrapper = styled(ActionsWrapper)(_templateObject4(), function (props) {
  return props.notClickable ? 'none' : 'auto';
}, ICN_SIZE);
var InputComponent = FieldBase.withComponent(ClearedInput);
var MaskedInput = styled(InputComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['offsetRight', 'cursorType', 'truncate', 'isInvalid'].includes(prop);
  }
}).attrs({
  as: InputMask
})(_templateObject5());
var Input = styled(InputComponent)(_templateObject6(), FIELD_HEIGHT, function (props) {
  return props.offsetRight ? "".concat(props.offsetRight, "px") : null;
}, function (props) {
  return props.truncate ? 'ellipsis' : null;
}, placeholder, ActionsWrapper, ClearWrapper, ICN_SIZE);
var Count = styled.div(_templateObject7(), color.textSecondary);
export var TextField = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextField, _PureComponent);

  var _super = _createSuper(TextField);

  function TextField() {
    var _this;

    _classCallCheck(this, TextField);

    _this = _super.apply(this, arguments);
    _this.input = _this.props.inputRef || createRef();
    _this.actions = createRef();
    _this.state = {
      hasValue: !!_this.value
    };
    _this.maskInitialValue = _this.props.mask ? getInitialMaskValue(_this.props.mask) : '';

    _this.handleChange = function (e) {
      _this.setState({
        hasValue: !!e.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this.clear = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClear = _this$props.onClear;
      var field = _this.input.current;
      if (!field) return;
      field.value = ''; // reset uncontrolled value

      _this.setState({
        hasValue: false
      });

      if (onClear) {
        onClear({
          target: field
        });
        return;
      }

      if (onChange) onChange({
        target: field
      });
    };

    return _this;
  }

  _createClass(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.clearBtnVisible || this.props.infieldActions) {
        /**
         * If it has action on the right (clear button or infieldActions),
         * update it after the mount to calculate `this.actionsWidth`.
         */
        this.forceUpdate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevValue = _ref.value;
      var value = this.props.value; // When value is changed manually from top - not from `onChange`

      if (!this.state.hasValue && !!value && prevValue !== value) {
        this.setState({
          hasValue: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dataE2eTitleLabel = "".concat(this.props.id, "-").concat(E2E_TITLE_SUFFIX);
      var dataE2eInputLabel = getE2eLabel(this.props.id, E2E_INPUT_SUFFIX);

      var _a = this.props,
          id = _a.id,
          label = _a.label,
          errorText = _a.errorText,
          disabled = _a.disabled,
          hiddenLabel = _a.hiddenLabel,
          clearable = _a.clearable,
          icon = _a.icon,
          infieldActions = _a.infieldActions,
          showCount = _a.showCount,
          maxLength = _a.maxLength,
          onClear = _a.onClear,
          hideError = _a.hideError,
          role = _a.role,
          hint = _a.hint,
          isOptional = _a.isOptional,
          mask = _a.mask,
          truncateLabel = _a.truncateLabel,
          description = _a.description,
          inputProps = __rest(_a, ["id", "label", "errorText", "disabled", "hiddenLabel", "clearable", "icon", "infieldActions", "showCount", "maxLength", "onClear", "hideError", "role", "hint", "isOptional", "mask", "truncateLabel", "description"]);

      return React.createElement(FieldWrapper, {
        id: id,
        errorText: errorText,
        hideError: hideError,
        role: role,
        hint: hint
      }, React.createElement(Label, {
        disabled: disabled,
        visuallyHidden: hiddenLabel,
        htmlFor: id,
        isOptional: isOptional,
        truncate: truncateLabel,
        dataE2e: dataE2eTitleLabel
      }, label), !!description && React.createElement(FieldDescription, {
        id: id,
        description: description
      }), React.createElement(InputWrapper, null, !!icon && React.createElement(IcnWrapper, {
        notClickable: icon.type === Icon
      }, icon), React.createElement(Input, Object.assign({}, inputProps, !!mask && {
        mask: mask,
        as: MaskedInput
      }, {
        id: id,
        disabled: disabled,
        isInvalid: !!errorText,
        ref: this.input,
        offsetRight: this.actionsWidth,
        maxLength: maxLength,
        onChange: this.handleChange,
        cursorType: "text",
        "data-e2e": dataE2eInputLabel
      })), React.createElement(ActionsWrapper, {
        ref: this.actions
      }, this.clearBtnVisible && React.createElement(ClearWrapper, null, React.createElement(ClearButton, {
        onClick: this.clear,
        inputId: id,
        label: label
      })), showCount && React.createElement(Count, null, this.value.length, maxLength ? " / ".concat(maxLength) : null), infieldActions)));
    }
  }, {
    key: "value",
    get: function get() {
      if (this.input.current) return this.input.current.value;
      return this.props.value || this.props.defaultValue || '';
    }
  }, {
    key: "clearBtnVisible",
    get: function get() {
      var _this$props2 = this.props,
          clearable = _this$props2.clearable,
          disabled = _this$props2.disabled,
          value = _this$props2.value,
          mask = _this$props2.mask;
      var showClearButton = clearable && this.state.hasValue && !disabled;

      if (mask) {
        return showClearButton && !!value && value !== this.maskInitialValue;
      }

      return showClearButton;
    }
  }, {
    key: "actionsWidth",
    get: function get() {
      return this.actions.current ? this.actions.current.offsetWidth : 0;
    }
  }]);

  return TextField;
}(PureComponent);
TextField.defaultProps = {
  type: 'text',
  onChange: function onChange() {
    return null;
  }
};